import * as Types from '../../../generated/graphql.types';

import gql from 'graphql-tag';
import * as Urql from 'urql';
import { graphql, ResponseResolver, GraphQLRequest, GraphQLContext } from 'msw'
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RemoveUserMutationVariables = Types.Exact<{
  input: Types.RemoveUserInput;
}>;


export type RemoveUserMutation = { __typename?: 'MutationRoot', removeUser: { __typename?: 'RemoveUserPayload', error?: string | null, user?: { __typename?: 'User', id: string, name: string } | null } };


export const RemoveUserDocument = gql`
    mutation removeUser($input: RemoveUserInput!) {
  removeUser(input: $input) {
    user {
      id
      name
    }
    error
  }
}
    `;

export function useRemoveUserMutation() {
  return Urql.useMutation<RemoveUserMutation, RemoveUserMutationVariables>(RemoveUserDocument);
};

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRemoveUserMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ removeUser })
 *   )
 * })
 */
export const mockRemoveUserMutation = (resolver: ResponseResolver<GraphQLRequest<RemoveUserMutationVariables>, GraphQLContext<RemoveUserMutation>, any>) =>
  graphql.mutation<RemoveUserMutation, RemoveUserMutationVariables>(
    'removeUser',
    resolver
  )
